import { fromJS } from 'immutable';

import {ApiReport, UserToken} from '../../../helper/HelperAuth'
import {GetReportSession, GlobalLoading} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, body) => async (dispatch, getState) => {

    dispatch({ type: GlobalLoading, showLoading: true});
    const Authorization = UserToken;
    //


    var query = {
        'search':body,
        'page':page,
        'page-size':10,
        'order-by':2,
        'order':'DESC',
    };

    //
    const url = ApiReport + 'report-session-list';
    if(page === undefined){
        page = 1;
    }

    if(search != null){
        search.map((v,k)=>{
            if(v !== ''){
                query[k] = v;
            }
        });
    }

    var paramBody = {
        'query': query
    };

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());

        var items = []
        data.get('data').map((item) => {
            var reqData = item.get('request-data');
            items.push({
                'client-id': reqData.get('client-id'),
                'division-id': reqData.get('division-id'),
                'sender-id': reqData.get('sender-id'),
                'template-id': reqData.get('template-id'),
                'start-date': reqData.get('start-date'),
                'end-date': reqData.get('end-date'),
                'request-data': item.get('request-data'),
                'requestid': item.get('requestid'),
                'client-name': item.get('client-name'),
                'division-name': item.get('division-name'),
                'file-name': item.get('file-name'),
                'file-path': item.get('file-path'),
                'request-date': item.get('request-date'),
                'status': item.get('status'),
                'summary-file': item.get('summary-file'),
                'summary-path':item.get('summary-path'),
                'summary-status':item.get('summary-status'),
                'report-format':item.get('report-format'),
                'reportFormatName':item.get('report-format-name'),
                'reportLinkSummary':item.get('report-link-summary'),
                'reportLinkDetail':item.get('report-link-detail'),
                'part':item.get('part'),
            })
        })

        var data2 = {
            'row-count': data.get('row-count'),
            'page-size': data.get('page-size'),
            'page-count': data.get('page-count'),
            'order-by': data.get('order-by'),
            'page': data.get('page'),
            'order': data.get('order'),
            'data': items
        }
    }

    dispatch({ type: GlobalLoading, showLoading: false});
    dispatch({ type: GetReportSession, data: fromJS(data2) });
};